module.exports = __webpack_public_path__ + "img/jq_4.e6a962a7.png";